import {categoryClasses, categoryColorClass, KeyboardKeys, priorityClasses, priorityColorClass} from "./utils/consts";

const customSelect = ({
  selectSelector = `.js-select`,
  selectListSelector = `.js-select-list`,
  inputSelector = `.js-select-input`,
  itemSelectors = `.js-select-item`,
  hiddenInputSelector = `.js-select-h-input`,
  activeItemClass,
  isPrioritySelect,
  isResponsibleSelect,
  isCategorySelect,
  multiselect = false,
  openClass = `show`,
}) => {
  const selects = document.querySelectorAll(selectSelector);

  const openSelect = ({selectElement, withoutClick, pressEscape, adaptiveHeightElement, parent, onWindowScroll}) => {
    // Проверка если селект находится ближе к концу экрана, то открываем выпадающий список вверх
    if (adaptiveHeightElement && parent && onWindowScroll) {
      if (getRect(parent, `top`) >= 500) {
        selectElement.classList.add(`top`);
      } else {
        selectElement.classList.remove(`top`);

        window.addEventListener(`scroll`, onWindowScroll);
      }
    }

    selectElement.classList.add(openClass);
    document.addEventListener(`click`, withoutClick);
    document.addEventListener(`touchstart`, withoutClick);
    document.addEventListener(`keydown`, pressEscape);
  };

  const closeSelect = ({selectElement, withoutClick, pressEscape, onWindowScroll}) => {
    selectElement.classList.remove(openClass);
    document.removeEventListener(`click`, withoutClick);
    document.removeEventListener(`touchstart`, withoutClick);
    document.removeEventListener(`keydown`, pressEscape);

    if (onWindowScroll) {
      window.removeEventListener(`scroll`, onWindowScroll);
    }
  };

  const resetSelect = ({defaultValue, defaultHiddenValue, inputElement, hiddenInputElement}) => {
    if (inputElement.tagName === `INPUT`) {
      inputElement.value = defaultValue;
    } else {
      inputElement.textContent = defaultValue;
    }

    hiddenInputElement.value = defaultHiddenValue;
  };

  const createEvent = (name) => {
    const event = new Event(name, {bubbles: true, cancelable: true});
    return event;
  };

  function getRect(element, rect) {
    let rectValue;

    switch (rect) {
      case `top`:
        rectValue = element.getBoundingClientRect().top;
        break;
      case `bottom`:
        rectValue = element.getBoundingClientRect().bottom;
        break;
    }
    return +rectValue.toFixed(0);
  }

  if (selects.length) {
    selects.forEach((select) => {
      const selectElement = select.querySelector(selectListSelector);
      const inputElement = select.querySelector(inputSelector);
      const itemsElements = selectElement.querySelectorAll(itemSelectors);
      const hiddenInput = select.querySelector(hiddenInputSelector);

      const adaptiveHeightElement = selectElement.querySelector(`.js-adaptive-height-element`);

      const defaultValue = inputElement.tagName === `INPUT` ? inputElement.value : inputElement.textContent;
      const defaultHiddenValue = hiddenInput.value;

      let multiselectValues = [];
      const multiselectTextValues = [];

      let currentElement = selectElement.querySelector(`.${activeItemClass}`);

      const withoutSelectClickHandler = (evt) => {
        if (evt.target.closest(selectSelector) !== select) {
          closeSelect({selectElement, withoutClick: withoutSelectClickHandler, pressEscape: onSelectPressEscape, onWindowScroll});
        }
      };

      const onSelectPressEscape = (evt) => {
        if (evt.code === KeyboardKeys.ESCAPE) {
          closeSelect({selectElement, withoutClick: withoutSelectClickHandler, pressEscape: onSelectPressEscape, onWindowScroll});
        }
      };

      const onWindowScroll = () => {
        adaptiveHeightElement.style.setProperty(`--adaptive-height`, `${getRect(inputElement, `top`)}px`);
      }

      const toggleSelectStatus = () => {
        if (selectElement.classList.contains(openClass)) {
          closeSelect({selectElement, withoutClick: withoutSelectClickHandler, pressEscape: onSelectPressEscape, onWindowScroll});
        } else {
          openSelect({
            selectElement,
            withoutClick: withoutSelectClickHandler,
            pressEscape: onSelectPressEscape,
            parent: inputElement,
            adaptiveHeightElement,
            onWindowScroll
          });
        }
      };

      const onInputKeyDown = (evt) => {
        if (evt.code === KeyboardKeys.SPACE || evt.code === KeyboardKeys.ENTER) {
          evt.preventDefault();

          toggleSelectStatus();
        }

        if (evt.code === KeyboardKeys.ARROW_DOWN) {
          evt.preventDefault();
          itemsElements[0].focus();
        }
      };

      const multiselectInit = () => {
        const value = hiddenInput.value ? JSON.parse(hiddenInput.value) : undefined;

        if (value && value.length) {
          multiselectValues = value;

          value.forEach((valueElement) => {
            const selectedElement = Array.from(selectElement.querySelectorAll(itemSelectors)).find(
              (selectItem) => +selectItem.dataset.value === valueElement,
            );

            if (selectedElement) {
              selectedElement.dataset.selected = `true`;

              multiselectTextValues.push(selectedElement.textContent);

              if (inputElement.tagName === `INPUT`) {
                inputElement.value = multiselectTextValues.toString();
              } else {
                inputElement.textContent = multiselectTextValues.toString();
              }
            }
          });
        }
      };

      if (multiselect) {
        multiselectInit();
      }

      if (isCategorySelect) {
        select.querySelector(`.js-category-select-open`).addEventListener(`click`, toggleSelectStatus);
      } else {
        inputElement.addEventListener(`click`, toggleSelectStatus);
      }

      inputElement.addEventListener(`keydown`, onInputKeyDown);

      const setCurrentItem = (evt) => {
        try {
          const target = evt.target.classList.contains(itemSelectors) ? evt.target : evt.target.closest(itemSelectors);

          if (target) {
            if (isResponsibleSelect) {
              const userItemImageElement = target.querySelector(`.responsible__icon`);
              const userCommonNameElement = select.querySelector(`.js-responsible-name`);
              const userCommonImageElement = select.querySelector(`.js-responsible-img`);

              const userImageSrc = userItemImageElement.src;
              const userImageAlt = userItemImageElement.alt;

              userCommonNameElement.textContent = target.textContent;

              if (userCommonImageElement) {
                userCommonImageElement.src = userImageSrc;
                userCommonImageElement.alt = userImageAlt;
              }
            } else {
              if (!multiselect) {
                if (inputElement.tagName === `INPUT`) {
                  inputElement.value = target.textContent;
                } else {
                  inputElement.textContent = target.textContent;
                }
              }
            }

            if (multiselect) {
              if (target.dataset.selected === `true`) {
                target.dataset.selected = `false`;

                if (multiselectValues.length === 1) {
                  multiselectValues.pop(+target.dataset.value);
                  multiselectTextValues.pop(target.textContent);
                } else {
                  const removedValue = multiselectValues.find((value) => value === +target.dataset.value);

                  if (removedValue) {
                    const removedIndex = multiselectValues.indexOf(removedValue);

                    multiselectValues.splice(removedIndex, 1);
                    multiselectTextValues.splice(removedIndex, 1);
                  }
                }
              } else {
                target.dataset.selected = `true`;

                multiselectValues.push(+target.dataset.value);
                multiselectTextValues.push(target.textContent);
              }

              if (inputElement.tagName === `INPUT`) {
                inputElement.value = multiselectTextValues.toString();
              } else {
                inputElement.textContent = multiselectTextValues.toString();
              }

              if (multiselectValues.length) {
                hiddenInput.value = JSON.stringify(multiselectValues);
              } else {
                hiddenInput.removeAttribute(`value`);
                inputElement.textContent = defaultValue;
              }
            } else {
              hiddenInput.value = target.dataset.value;
            }

            if (isPrioritySelect) {
              const parent = inputElement.parentNode;
              const currentColorClass = priorityClasses.filter((element) => parent.classList.contains(element));

              parent.classList.remove(currentColorClass);
              parent.classList.add(priorityColorClass[target.dataset.value]);
            }

            if (isCategorySelect) {
              const currentIconElement = select.querySelector(`.js-category-select-c-icon use`);
              const iconElement = inputElement.parentNode.querySelector(`.js-category-select-c-icon`);
              const iconParentElement = iconElement.parentNode;

              const currentColorClass = categoryClasses.filter((element) => iconParentElement.classList.contains(element));
              iconParentElement.classList.remove(currentColorClass);
              iconParentElement.classList.add(categoryColorClass[target.dataset.categoryType]);
              const url = target.querySelector(`use`).href.baseVal;
              currentIconElement.setAttribute("href", url);
            }

            if (currentElement) {
              currentElement.classList.remove(activeItemClass);
            }

            if (!multiselect) {
              target.classList.add(activeItemClass);
              currentElement = target;

              inputElement.dispatchEvent(createEvent(`change`));
              hiddenInput.dispatchEvent(createEvent(`change`));

              closeSelect({
                selectElement,
                withoutClick: withoutSelectClickHandler,
                pressEscape: onSelectPressEscape,
                onWindowScroll
              });
            }
          }
        } catch (e) {
          // @ts-ignore
          if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
            // @ts-ignore
            window.sendError.sendMessage(e);
          }
        }
      };

      itemsElements.forEach((item, index) => {
        const onSelectItemKeydownPress = (evt) => {
          switch (evt.code) {
            case KeyboardKeys.ARROW_DOWN:
              evt.preventDefault();
              if (index + 1 === itemsElements.length) {
                itemsElements[0].focus();
              } else {
                itemsElements[index + 1].focus();
              }
              break;
            case KeyboardKeys.ARROW_UP:
              evt.preventDefault();
              if (index - 1 < 0) {
                itemsElements[itemsElements.length - 1].focus();
              } else {
                itemsElements[index - 1].focus();
              }
              break;
            case KeyboardKeys.SPACE:
              evt.preventDefault();
              setCurrentItem(evt);
              break;
            case KeyboardKeys.ENTER:
              evt.preventDefault();
              setCurrentItem(evt);
              break;
          }
        };

        // item.addEventListener(`click`, setCurrentItem);
        item.addEventListener(`keydown`, (evt) => {
          try {
            onSelectItemKeydownPress(evt);
          } catch (e) {
            if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
              // @ts-ignore
              window.sendError.sendMessage(error);
            }
          }
        });
      });

      selectElement.addEventListener(`click`, setCurrentItem);
      selectElement.addEventListener(`closeSelect`, () => {
        try {
          closeSelect({
            selectElement,
            withoutClick: withoutSelectClickHandler,
            pressEscape: onSelectPressEscape,
            onWindowScroll,
          });
        } catch (error) {
          // @ts-ignore
          if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
            // @ts-ignore
            window.sendError.sendMessage(error);
          }
        }
      });
      selectElement.addEventListener(`setItem`, setCurrentItem);
      selectElement.addEventListener(`openSelect`, () => {
        try {
          openSelect({
            selectElement,
            withoutClick: withoutSelectClickHandler,
            pressEscape: onSelectPressEscape,
            parent: inputElement,
            adaptiveHeightElement,
            onWindowScroll,
          });
        } catch (error) {
          // @ts-ignore
          if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
            // @ts-ignore
            window.sendError.sendMessage(error);
          }
        }
      });
      hiddenInput.addEventListener(`resetSelect`, () => {
        try {
          resetSelect({defaultValue, defaultHiddenValue, inputElement, hiddenInputElement: hiddenInput});
        } catch (error) {
          // @ts-ignore
          if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
            // @ts-ignore
            window.sendError.sendMessage(error);
          }
        }
      });
    });
  }
};

export default customSelect;
